import React from 'react';

const Section = ({title, children}) => (
  <div>
    <h5>
      {title && title}
      <div
        className="kt-margin-t-10"
        style={{
          backgroundColor: '#e1e1ef',
          height: '1px',
        }}
      />
    </h5>
    {children && children}
  </div>
);

export default Section;
